import { render } from "./LandingHomePage.vue?vue&type=template&id=f4b1b3d4"
import script from "./LandingHomePage.vue?vue&type=script&lang=js"
export * from "./LandingHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__